import { useState } from "react";
import Input from "../../../design/Input";
import InputCreditCard from "../../../design/InputCreditCard";
import InputDateFourNumbers from "../../../design/InputDateFourNumbers";
import TableDatalis from "./TableDatalis";
import regx from "../../../../functions/regx";



export default function CraditCard ({data, setData}) {
    const templateCredit = {number: '', cvv: '', date: '', id: data.id};
    const [dataCredit, setDataCredit] = useState(templateCredit);
    const head = ["מס'", "מספר", "תאריך", "CVV", "מ.ז.", ""];

    const insertCredit = () => {
        if (regx('creditCard', dataCredit.number, false) && regx('dateCreditCard', dataCredit.date, false) && 
        regx(/^[0-9]{3,4}$/, dataCredit.cvv, false) && regx('id', dataCredit.id)) {

            const keys = Object.keys(data.credit);
            let num = (keys.length ? Math.max(...keys) : 0) + 1;
            setData({...data, credit: {...data.credit, [num]: dataCredit}});
            setDataCredit(templateCredit);
        }
    }

    return (
        <div>
            <div className="divcraditcard">
                <p>מספר אשראי</p>

                <InputCreditCard
                textView={'0000 0000 0000 0000'}
                value={dataCredit.number}
                onChange={(e) => setDataCredit({...dataCredit, number: e})}
                myStyle={'input2'}
                pattern={'creditCard'}
                />

                <p>תאריך</p>
                <InputDateFourNumbers
                textView={'MM/YY'}
                value={dataCredit.date}
                onChange={(e) => setDataCredit({...dataCredit, date: e})}
                myStyle={'input2'}
                pattern={'dateCreditCard'}
                />

                <p>CVV</p>
                <Input
                textView={'CVV'}
                myStyle={'input2'}
                value={dataCredit.cvv}
                onChange={(e) => setDataCredit({...dataCredit, cvv: e})}
                pattern={/^[0-9]{3,4}$/}
                />

                <p>מס. זהות</p>

                <Input
                textView={'מ.ז'}
                myStyle={'input2'}
                value={dataCredit.id}
                onChange={(e) => setDataCredit({...dataCredit, id: e})}
                pattern={'id'}
                />
            </div>

            <p onClick={insertCredit} className="addPasspord"> הוסף \ עדכן</p>

            <TableDatalis
            name={'credit'}
            head={head}
            data={data.credit}
            myDelete={(value) => {
                let credit = {...data.credit};
                delete credit[value];
                setData({...data, credit: credit});
            }}
            />
        </div>
    )
}